import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import { DELETE_WORKFLOW } from "utils/api/graphql/mutations/workflows";
import { WORKFLOWS } from "utils/api/graphql/queries/workflows";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.WORKFLOWS.LIST.path);
  const [deleteWorkflow] = useMutation(DELETE_WORKFLOW, {
    refetchQueries: [
      {
        query: WORKFLOWS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
      {
        query: WORKFLOWS,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.ADMIN.WORKFLOWS.LIST.path, { replace: true });
    },
  });
  const onSubmit = () => {
    return deleteWorkflow({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
